import { render, staticRenderFns } from "./HoldingCompanies.vue?vue&type=template&id=6654b776"
import script from "./HoldingCompanies.vue?vue&type=script&lang=ts"
export * from "./HoldingCompanies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports